"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarredMessageAdapter = void 0;
const Urls_1 = require("../Urls");
/* eslint-disable no-useless-catch */
class StarredMessageAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    fetchStarredMessages(data, organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(`${this.config.baseUrl + Urls_1.urls.starMessage}?total=${data.total}`, organizationId && {
                    headers: {
                        "x-hhn-active-org-id": organizationId,
                    },
                });
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.StarredMessageAdapter = StarredMessageAdapter;
